import Model  from '@/util/models';
import Dapil  from './Dapil';
import Partai from './Partai';


export default class Kompetisi extends Model { 
    backend = '/frc/analisis/'; 
       
    kompetisis(params){
        return this.api.get(this.backend + 'kompetisis', params);
    }
    
    kompetisi(params){
        return this.api.get(this.backend + 'kompetisi', params);
    }
    
    tps(params){
        return this.api.get(this.backend + 'tps', params).then(res => {
            return res.status === 200 ? res.data : [];
        })
    }
}

